import AutoCompleteInput, { AutoCompleteInputBlock } from './components/AutoCompleteInput';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;
  const { labels, types, labelAutocompleteInputCategory } = opts;
  AutoCompleteInputBlock(bm, labelAutocompleteInputCategory, labels, types);
  AutoCompleteInput(dc, labels.autocompleteInputContainer, types.autocompleteInputContainer, opts);
};
